"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTooltip = void 0;
const react_1 = __importStar(require("react"));
const tooltip_1 = require("@visx/tooltip");
const list_1 = require("./list");
function useTooltip() {
    const svgRef = (0, react_1.createRef)();
    const [content, setContent] = (0, react_1.useState)();
    const [data, setData] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!data)
            return setContent(undefined);
        const { top, left, renderer } = data;
        const TooltipElement = (react_1.default.createElement(tooltip_1.TooltipWithBounds, { top: top, left: left }, typeof renderer === "function"
            ? renderer(data)
            : (0, list_1.ChartTooltipList)(data)));
        setContent(TooltipElement);
    }, [data]);
    const positionSVGTooltip = (0, react_1.useCallback)((e, svg, data) => {
        const { clientX, clientY } = e;
        const rect = svg === null || svg === void 0 ? void 0 : svg.getBoundingClientRect();
        setData(Object.assign(Object.assign({}, data), { left: clientX - rect.left + 15, top: clientY - rect.top + 15 }));
    }, [data]);
    function hideTooltip() {
        setContent(undefined);
        setData(undefined);
    }
    return {
        show: setData,
        hide: hideTooltip,
        svgRef,
        element: content,
        positionSVGTooltip,
        data,
    };
}
exports.useTooltip = useTooltip;
//# sourceMappingURL=main.js.map